import { Text } from "@ds/react";
import { ReactComponent as ErroIcon } from "assets/icons/cabo-desconectado.svg";
import { phoneToHref } from "utils/string";
import ResponsiveCard from "components/ResponsiveCard";
import { openChat } from "utils/chat";
import * as S from "./ErroGenerico.style";
import Section from "components/Section";

const ErroGenerico = () => {
  return (
    <Section>
      <ResponsiveCard
        title=" Ops, algo deu errado :("
        subtitle=" Estamos com algum problema em nossos sistemas e não conseguimos
    concluir a sua ação. Por favor, tente de novo mais tarde."
      >
        <S.Box>
          <ErroIcon height="100%" width="100%" />
          <Text variant="body-02-md" display="block">
            Se estiver com dificuldade, fale com a gente pelo{" "}
            <S.StyledLink onClick={openChat}>Chat</S.StyledLink> ou ligue para{" "}
            <S.StyledLink href={phoneToHref("0800 272 2021")}>
              0800 272 2021
            </S.StyledLink>
            .
          </Text>
        </S.Box>
      </ResponsiveCard>
    </Section>
  );
};

export default ErroGenerico;
